// extracted by mini-css-extract-plugin
module.exports = {"teams":"styles_teams__2ZoPx"};